namespace app.support {
    "use strict";

    declare var loadCSS;
    declare var onloadCSS;
    
    export class StylesLoadingService {
        
        public constructor(private $q: ng.IQService) {
            
        }
        
        public loadStyle(styleUrl: string): ng.IPromise<{}> {
         // Carregamento dos estilos dos contextos.
            let styleUrlTs = this.getUrlWithTimestamp(styleUrl);
            return this.$q((resolve) => {
                if (this.isCssAlreadyPresent(styleUrl)) {
                    resolve();
                } else {
                    let styleElement = loadCSS(styleUrlTs);
                    onloadCSS(styleElement, () => {
                        resolve();
                    });
                }
            });
        }
        
        /**
         * Verifica se um CSS já está presente na tela.
         * 
         * @param path
         */
        private isCssAlreadyPresent(path: string) {
            let present = false;
            for (let i = 0; i < document.styleSheets.length; i++) {
                if (document.styleSheets[i].href && document.styleSheets[i].href.startsWith(path)) {
                    present = true;
                    break;
                }
            }
            return present;
        }
        
        /**
         * Monta uma url com um timestamp na querystring.
         * 
         * @param url
         */
        private getUrlWithTimestamp(url) {
            return url + (url.indexOf("?") === -1 ? "?" : "&") + "ts=" + Date.now().toString();
        }
    }
    
    angular.module('app.support')
            .service('stylesLoadingService', StylesLoadingService);
    
}